import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

export const translations = {
  en: {
    brand: 'Oblitrok',
    nav: {
      hireTalent: 'Hire talent',
      getOutcomes: 'Get outcomes',
      findWork: 'Find work',
      findServices: 'Find Services',
      findExperts: 'Find Experts',
      findTasks: 'Requirement Hall',
      why: 'Why Oblitrok',
      pricing: 'Pricing',
      enterprise: 'Enterprise',
      login: 'Log in',
      signup: 'Sign up',
      deliverWork: 'Deliver work',
      publishService: 'Post Service',
      finances: 'Finance Center',
      messages: 'Messages',
      jobs: 'Services',
      search: 'Search',
      language: 'Language',
      help: 'Help',
      notifications: 'Notifications',
      settings: 'Settings',
      freelancer: 'Freelancer',
      onlineForMessages: 'Online for messages',
      yourProfile: 'Your profile',
      statsAndTrends: 'Stats and trends',
      accountHealth: 'Account health',
      connects: 'Finance Center',
      theme: 'Theme',
      accountSettings: 'Account settings',
      logout: 'Log out',
    },
    categories: {
      全部: 'All',
      生活服务: 'Lifestyle',
      学习成长: 'Learning',
      创意制作: 'Creative',
      技术服务: 'Development',
      健康运动: 'Health',
      宠物服务: 'Pets',
    },
    categoryItems: {
      生活服务: 'Cleaning · Repairs · Moving · Errands',
      学习成长: 'Languages · Music · Exams · Career coaching',
      创意制作: 'Photo · Video · Design · Copywriting',
      技术服务: 'Websites · Automation · Data · Software help',
      健康运动: 'Fitness · Sports · Yoga · Recovery',
      宠物服务: 'Pet sitting · Walking · Grooming · Training',
    },
    methods: {
      全部: 'Any type',
      上门: 'On-site',
      到店: 'In-store',
      远程: 'Remote',
      混合: 'Hybrid',
    },
    home: {
      bannerLabel: 'Business Plus',
      bannerText: 'Find more reliable skill providers and deliver complex projects faster.',
      bannerCta: 'Get started',
      heroTitle: 'Work at the speed of your ambition',
      hireIntent: 'I want to hire',
      workIntent: 'I want to work',
      searchPlaceholder: 'Search for skills, services, or requirements',
      searchButton: 'Search',
      popularLabel: 'Popular searches',
      popularSearches: [
        'AI chatbot developer for support automation',
        'Creative director for brand identity',
        'Data analyst for churn modeling',
        'Video editor for promo content',
        'Automation expert for workflows',
        'Web developer for redesign',
      ],
      heroCardTitle: 'React / Node enterprise web development',
      heroCardMeta: 'Top rated · 48 orders · 30 min response',
      heroCardSkills: ['React', 'Node.js', 'Deployment'],
      ratingLabel: 'Average rating',
      ordersLabel: 'Completed orders',
      categoriesTitle: 'Find freelancers for every type of work',
      exploreMore: 'Explore more',
      howTitle: 'How it works',
      hiringTab: 'For hiring',
      workTab: 'For finding work',
      steps: [
        { title: 'Posting a requirement is always free', text: 'Describe the goal in one sentence, then refine scope, budget, and delivery expectations.', cta: 'Create a requirement' },
        { title: 'Shortlist and talk to talent', text: 'Compare portfolios, ratings, response speed, and past orders before you choose.', cta: 'Explore experts' },
        { title: 'Pay after delivery is accepted', text: 'Keep milestones, messages, files, orders, and reviews in one shared workspace.', cta: 'View services' },
      ],
      plansTitle: 'Choose how you want to hire',
      basicTitle: 'Built for small projects and occasional needs',
      basicText: 'Post a requirement, compare providers, and accept work based on clear deliverables.',
      businessTitle: 'Built for teams and ongoing outsourcing',
      businessText: 'Use stronger talent shortlists, project workspaces, and delivery management.',
      planCta: 'Get started for free',
      finalTitle: "Find freelancers who can help you build what's next",
      finalCta: 'Explore freelancers',
    },
    auth: {
      loginTitle: 'Log in to Oblitrok',
      signupTitle: 'Sign up for Oblitrok',
      usernameOrEmail: 'Username or Email',
      password: 'Password',
      username: 'Username',
      email: 'Email',
      passwordHint: 'Password, at least 8 characters',
      remember: 'Remember me',
      forgot: 'Forgot password?',
      consentPrefix: 'You have read and agree to Oblitrok’s',
      termsLink: 'Terms of Use',
      privacyLink: 'Privacy Policy',
      consentJoiner: 'and',
      consentRequired: 'Please read and agree to the Terms of Use and Privacy Policy.',
      continue: 'Continue',
      loggingIn: 'Logging in...',
      createAccount: 'Create account',
      registering: 'Creating account...',
      or: 'or',
      google: 'Continue with Google',
      apple: 'Continue with Apple',
      googleUnavailable: 'Google login is not connected yet. Please use email login first.',
      appleUnavailable: 'Apple login is not connected yet. Please use email login first.',
      demo: 'Continue as Demo',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      signup: 'Sign Up',
      login: 'Log In',
      footer: '© 2015 - 2026 Oblitrok Global LLC · Privacy Policy · Your Privacy Choices',
      passwordLength: 'Password must be at least 8 characters',
      loginTimeout: 'The server is waking up. Please wait a moment and try again.',
      loginFailed: 'Login failed. Please confirm the API server is running.',
      loginRequired: 'Please sign in before continuing to this workspace.',
      demoFailed: 'Demo login failed. Please wait a moment and try again.',
      registerTimeout: 'Registration timed out. Please confirm the API server is running.',
      registerFailed: 'Registration failed. Please confirm the API server is running.',
    },
    store: {
      breadcrumbHome: 'Home',
      breadcrumbStore: 'Skill service store',
      title: 'Oblitrok skill services',
      subtitle: 'Choose a service package or post a requirement and wait for quotes. Profiles, verification, reviews, and escrow orders stay inside the platform.',
      searchPlaceholder: 'Search service, provider, or skill',
      searchButton: 'Search',
      provider: 'Provider',
      response: 'Response',
      rating: 'Rating',
      orders: 'Orders',
      mode: 'Mode',
      range: 'Range',
      available: 'available',
      limited: 'Limited availability',
      serviceId: 'Service ID',
      details: 'View details',
      book: 'Book now',
      workspaceTitle: 'Added to workspace',
      workspaceText: 'Based on your selected services, we recommend refining requirements, budget range, and acceptance criteria.',
      workspaceCta: 'Continue posting',
      addons: 'Additional modules',
    },
    services: {
      findWork: 'Find services',
      best: 'Best Matches',
      recent: 'Newest services',
      saved: 'Saved services',
      category: 'Category',
      type: 'Service type',
      experience: 'Experience level',
      budget: 'Budget',
      title: 'Find reliable skill services',
      subtitle: 'Compare providers by scope, delivery method, reputation, budget, and response speed before you start an order.',
      updateProfile: 'Update profile',
      searchPlaceholder: 'Search services',
      search: 'Search',
      filters: 'Filters',
      clearFilters: 'Clear filters',
      results: 'services found',
      allCategories: 'All categories',
      anyType: 'Any service type',
      verified: 'Verified client',
      rating: 'rating',
      jobsPosted: 'completed services',
      submit: 'View service',
      profileTitle: 'Provider workspace',
      profileRole: 'Manage your service profile',
      profileComplete: 'Keep your profile ready for clients',
      completeProfile: 'Complete your profile',
      connects: 'Connects',
      available: 'Available after account setup',
      connectsText: 'Use Connects to submit proposals to matching opportunities.',
      billing: 'View billing',
      tips: 'Tips for choosing a service',
      tipsText: 'Check scope, delivery time, reviews, and communication expectations before placing an order.',
      stats: 'Service stats',
      availableServices: 'Available services',
      savedServices: 'Saved services',
      profileViews: 'Profile views',
      invites: 'Invites',
      proposals: 'Proposals',
      serviceDescription: 'Service description',
      availability: 'Availability',
      caseStudies: 'Case studies',
      providerTrust: 'Provider profile and verification',
      serviceCount: 'services',
      providerSummary: 'has completed',
      scoreLabel: 'average rating',
      serviceRange: 'Service area',
      delivery: 'delivery',
      contactProvider: 'Contact provider',
      bookService: 'Book service',
      saveService: 'Save service',
      report: 'Report',
      noSaved: 'No saved services yet.',
      noResults: 'No matching services found.',
      beforeOrder: 'Confirm before ordering',
      beforeOrderText: 'Confirm time, location, scope, budget, cancellation rules, and contact protection before placing an order.',
    },
  },
  zh: {
    brand: 'Oblitrok',
    nav: {
      hireTalent: '雇佣人才',
      getOutcomes: '获得成果',
      findWork: '找工作',
      why: '为什么选 Oblitrok',
      findServices: '找服务',
      findExperts: '找专家',
      findTasks: '需求大厅',
      publishService: '发布服务',
      pricing: '价格',
      enterprise: '企业版',
      login: '登录',
      signup: '注册',
      deliverWork: '交付工作',
      finances: '财务中心',
      messages: '消息',
      jobs: '服务',
      search: '搜索',
      language: '语言',
      help: '帮助',
      notifications: '通知',
      settings: '设置',
      freelancer: '自由职业者',
      onlineForMessages: '在线接收消息',
      yourProfile: '个人资料',
      statsAndTrends: '数据与趋势',
      accountHealth: '账号健康',
      connects: '财务中心',
      theme: '主题',
      accountSettings: '账号设置',
      logout: '退出登录',
    },
    categories: {
      全部: '全部',
      生活服务: '生活服务',
      学习成长: '学习成长',
      创意制作: '创意制作',
      技术服务: '技术服务',
      健康运动: '健康运动',
      宠物服务: '宠物服务',
    },
    categoryItems: {
      生活服务: '保洁 · 维修安装 · 搬家 · 跑腿',
      学习成长: '语言辅导 · 乐器陪练 · 考试辅导 · 职业指导',
      创意制作: '摄影摄像 · 修图剪辑 · 平面设计 · 文案策划',
      技术服务: '网站制作 · 自动化脚本 · 数据整理 · 软件指导',
      健康运动: '健身陪练 · 球类陪练 · 瑜伽指导 · 康复陪练',
      宠物服务: '宠物照看 · 遛宠 · 洗护预约 · 训练陪伴',
    },
    methods: {
      全部: '不限方式',
      上门: '上门',
      到店: '到店',
      远程: '远程',
      混合: '混合',
    },
    home: {
      bannerLabel: 'Business Plus',
      bannerText: '找到更可靠的技能服务者，快速交付复杂项目。',
      bannerCta: '开始使用',
      heroTitle: '以你的雄心速度推进工作',
      hireIntent: '我要雇佣',
      workIntent: '我要接活',
      searchPlaceholder: '搜索技能、服务或需求',
      searchButton: '搜索',
      popularLabel: '热门搜索',
      popularSearches: ['AI 客服机器人开发', '品牌视觉创意总监', '流失预测数据分析', '宣传视频剪辑', '工作流自动化专家', '网站改版开发'],
      heroCardTitle: 'React / Node 企业网站开发',
      heroCardMeta: '顶级服务者 · 48 单 · 30 分钟响应',
      heroCardSkills: ['React', 'Node.js', '部署'],
      ratingLabel: '平均评分',
      ordersLabel: '已完成订单',
      categoriesTitle: '找到适合每类工作的自由职业者',
      exploreMore: '查看更多',
      howTitle: '如何运作',
      hiringTab: '雇佣人才',
      workTab: '寻找工作',
      steps: [
        { title: '发布需求始终免费', text: '用一句话描述项目，平台帮你整理目标、预算和交付范围。', cta: '发布需求' },
        { title: '筛选人才并沟通', text: '查看作品、评分、响应速度和历史订单，找到真正合适的人。', cta: '浏览专家' },
        { title: '验收后再付款', text: '按里程碑推进，聊天、文件、订单和评价都留在同一个工作台。', cta: '查看服务' },
      ],
      plansTitle: '选择你的雇佣方式',
      basicTitle: '适合偶发需求和小项目',
      basicText: '快速发布需求、筛选服务者、按结果验收。',
      businessTitle: '适合团队和持续外包',
      businessText: '更完整的人才短名单、项目工作台和交付管理。',
      planCta: '免费开始',
      finalTitle: '找到能帮你建设下一阶段的自由职业者',
      finalCta: '浏览自由职业者',
    },
    auth: {
      loginTitle: '登录 Oblitrok',
      signupTitle: '注册 Oblitrok',
      usernameOrEmail: '用户名或邮箱',
      password: '密码',
      username: '用户名',
      email: '邮箱',
      passwordHint: '密码，至少 8 位',
      remember: '记住我',
      forgot: '忘记密码？',
      consentPrefix: '您已阅读并同意 Oblitrok 的',
      termsLink: '《使用条款》',
      privacyLink: '《隐私政策》',
      consentJoiner: '和',
      consentRequired: '请先阅读并同意《使用条款》和《隐私政策》。',
      continue: '继续',
      loggingIn: '登录中...',
      createAccount: '创建账号',
      registering: '注册中...',
      or: '或',
      google: '使用 Google 继续',
      apple: '使用 Apple 继续',
      googleUnavailable: 'Google 登录暂未接入，请先使用邮箱登录。',
      appleUnavailable: 'Apple 登录暂未接入，请先使用邮箱登录。',
      demo: '使用 Demo 账号继续',
      noAccount: '还没有账号？',
      hasAccount: '已有账号？',
      signup: '注册',
      login: '登录',
      footer: '© 2015 - 2026 Oblitrok Global LLC · 隐私政策 · 隐私选择',
      passwordLength: '密码至少 8 位',
      loginTimeout: '后端服务正在唤醒，请稍等片刻后重新点击登录',
      loginFailed: '登录失败，请确认后端服务已启动',
      loginRequired: '请先登录后继续进入该工作区。',
      demoFailed: 'Demo 登录失败，请稍等片刻后重试',
      registerTimeout: '注册超时，请确认后端服务已启动',
      registerFailed: '注册失败，请确认后端服务已启动',
    },
    store: {
      breadcrumbHome: '首页',
      breadcrumbStore: '技能服务商店',
      title: 'Oblitrok 技能服务',
      subtitle: '选择一个服务套餐，或发布需求等待服务者报价。服务者资料、认证、评价与托管订单都可在平台内完成。',
      searchPlaceholder: '搜索服务名称、服务者或技能',
      searchButton: '搜索',
      provider: '服务者',
      response: '响应',
      rating: '评分',
      orders: '订单',
      mode: '方式',
      range: '范围',
      available: '可约',
      limited: '少量可约',
      serviceId: '服务编号',
      details: '查看详情',
      book: '立即预约',
      workspaceTitle: '已加入工作台',
      workspaceText: '基于技能服务，我们建议你继续完善需求描述、预算范围和验收标准。',
      workspaceCta: '继续发布需求',
      addons: '补充模块',
    },
    services: {
      findWork: '找服务',
      best: '最佳匹配',
      recent: '最新服务',
      saved: '已收藏',
      category: '分类',
      type: '服务方式',
      experience: '经验级别',
      budget: '预算',
      title: '匹配更可靠的技能服务',
      subtitle: '按服务范围、交付方式、信誉、预算和响应速度筛选服务，下单前更容易判断是否合适。',
      updateProfile: '更新资料',
      searchPlaceholder: '搜索服务',
      search: '搜索',
      filters: '筛选',
      clearFilters: '清除筛选',
      results: '项服务',
      allCategories: '全部分类',
      anyType: '不限服务方式',
      verified: '已验证客户',
      rating: '评分',
      jobsPosted: '已完成服务',
      submit: '查看服务',
      profileTitle: '服务者工作台',
      profileRole: '管理你的服务资料',
      profileComplete: '保持资料完整，方便客户判断',
      completeProfile: '完善资料',
      connects: '提案点数',
      available: '完成账号设置后可用',
      connectsText: '使用提案点数向匹配机会提交方案。',
      billing: '查看账单',
      tips: '选择服务的建议',
      tipsText: '下单前先确认服务范围、交付时间、评价记录和沟通方式。',
      stats: '服务数据',
      availableServices: '可接服务',
      savedServices: '收藏服务',
      profileViews: '资料浏览',
      invites: '邀请',
      proposals: '方案',
      serviceDescription: '服务说明',
      availability: '可预约时间',
      caseStudies: '案例展示',
      providerTrust: '服务者资料与认证',
      serviceCount: '次服务',
      providerSummary: '已完成',
      scoreLabel: '综合评分',
      serviceRange: '服务范围',
      delivery: '交付',
      contactProvider: '咨询服务者',
      bookService: '预约下单',
      saveService: '收藏服务',
      report: '举报',
      noSaved: '还没有收藏服务。',
      noResults: '没有找到匹配服务。',
      beforeOrder: '下单前需确认',
      beforeOrderText: '时间、地点、服务内容、预算、取消规则和联系方式保护方式。',
    },
  },
};

const LanguageContext = createContext(null);

const phraseMap = {
  en: {
    测试任务: 'Test requirement',
    单元测试: 'Unit test',
    固定悬赏: 'Fixed reward',
    计件悬赏: 'Piece reward',
    竞标悬赏: 'Bidding reward',
    固定预算: 'Fixed budget',
    按阶段报价: 'Milestone quote',
    服务者报价: 'Provider quote',
    自主提交: 'Open submission',
    邀请制: 'Invite only',
    公开竞标: 'Open bidding',
    平台公开: 'Open listing',
    定向邀请: 'Invite only',
    沟通后确认: 'Confirm after chat',
    按次: 'Per visit',
    按小时: 'Hourly',
    按天: 'Daily',
    按项目: 'Fixed project',
    面议: 'Negotiable',
    免费互助: 'Free mutual help',
    成果征集中: 'Open for submissions',
    协议签订中: 'Contracting',
    已完成: 'Completed',
    已关闭: 'Closed',
    家庭深度保洁与收纳整理: 'Home deep cleaning and closet organization',
    'React / Node 企业网站与管理后台开发': 'React / Node company website and admin system',
    中小学英语一对一辅导: 'One-on-one English tutoring for students',
    女性服务者: 'Female provider',
    可周末: 'Weekend available',
    自带工具: 'Tools included',
    可签协议: 'Agreement available',
    支持部署: 'Deployment support',
    可开票: 'Invoice available',
    远程: 'Remote',
    上门: 'On-site',
    到店: 'In-store',
    混合: 'Hybrid',
    生活服务: 'Lifestyle',
    学习成长: 'Learning',
    创意制作: 'Creative',
    技术服务: 'Development',
    健康运动: 'Health',
    宠物服务: 'Pets',
    数码电子: 'Electronics',
    家具家居: 'Furniture',
    母婴儿童: 'Kids & baby',
    文体乐器: 'Sports & instruments',
    九成新: 'Like new',
    八成新: 'Good condition',
    七成新: 'Fair condition',
    西湖区: 'Xihu District',
    滨江区: 'Binjiang District',
    上城区: 'Shangcheng District',
    拱墅区: 'Gongshu District',
    九成新人体工学办公椅: 'Ergonomic office chair in great condition',
    '索尼降噪耳机 WH-1000XM4': 'Sony noise-cancelling headphones WH-1000XM4',
    儿童平衡车: 'Kids balance bike',
    '闲置尤克里里 23 寸': 'Pre-owned 23-inch ukulele',
    '居家办公使用半年，靠背和升降功能正常，可自提。': 'Used for home office for six months. Backrest and height adjustment work normally. Self-pickup available.',
    '功能正常，含收纳盒和充电线，耳罩已更换。': 'Works normally. Includes case and charging cable. Ear pads have been replaced.',
    '适合 2-4 岁儿童，轮胎正常，车身有贴纸痕迹。': 'Suitable for children aged 2-4. Tires are normal, with sticker marks on the frame.',
    '入门练习琴，附琴包、调音器和备用弦。': 'Beginner practice instrument with bag, tuner, and spare strings.',
    '椅子无明显破损，扶手轻微使用痕迹。建议线下验货后交易。': 'No obvious damage. Armrests show minor use. Offline inspection recommended before trading.',
    '支持现场连接测试。贵重数码建议当面检查序列号和配件。': 'On-site connection test supported. For valuable electronics, check serial number and accessories in person.',
    '小区门口自提，介意外观使用痕迹请谨慎。': 'Self-pickup at the community gate. Please consider visible wear before buying.',
    '适合初学者，支持当面试音。': 'Good for beginners. In-person sound test supported.',
    '好的，我周一可以开始！': 'Great, I can start on Monday.',
    '设计文件已经发给你了': 'The design files have been sent to you.',
    科技创业公司: 'Tech startup',
    '什么时候能交付？': 'When can you deliver?',
    'App 准备好评审了': 'The app is ready for review.',
    昨天: 'Yesterday',
    周一: 'Mon',
    '嗨，我对你的 React 技能很感兴趣！': 'Hi, I am interested in your React skills.',
    '谢谢联系！我很想了解更多关于您的项目。': 'Thanks for reaching out. I would love to learn more about your project.',
    '我们需要一位全栈开发者来做电商平台，预算 25,000。': 'We need a full-stack developer for an ecommerce platform. Budget: 25,000.',
    '听起来很棒！我在电商领域经验丰富。可以电话沟通吗？': 'Sounds great. I have strong ecommerce experience. Can we schedule a call?',
    '你好 Ahmed，Logo 设计开始做了吗？': 'Hi Ahmed, have you started the logo design?',
    '是的！我已经做了 3 个概念版本，马上发给你。': 'Yes. I have prepared three concepts and will send them shortly.',
    '你好，我看到了你的提案。': 'Hi, I saw your proposal.',
    '是的！我非常感兴趣，我有 5 年以上 React Native 经验。': 'Yes, I am very interested and have over 5 years of React Native experience.',
    '太好了！我下午看一下。': 'Great. I will review it this afternoon.',
    软件工程: 'Software engineering',
    人工智能: 'Artificial intelligence',
    计算机学: 'Computer science',
    电子信息: 'Electronic information',
    通信工程: 'Communication engineering',
    大数据: 'Big data',
    理论研究: 'Theoretical research',
    知识图谱: 'Knowledge graph',
    机器人: 'Robotics',
    无人系统: 'Unmanned systems',
    创意征集: 'Creative call',
    文献翻译: 'Academic translation',
    医学: 'Medical',
    政策法规: 'Policy and regulation',
    其他: 'Other',
  },
  zh: {},
};

function translatePhrase(value, language) {
  if (value === null || value === undefined) return value;
  if (language === 'zh') return value;
  const raw = String(value);
  return phraseMap[language]?.[raw] || raw;
}

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => localStorage.getItem('language') || 'en');

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language === 'zh' ? 'zh-CN' : 'en';
  }, [language]);

  const value = useMemo(() => ({
    language,
    copy: translations[language],
    setLanguage: setLanguageState,
    localizeCategory: (name) => translations[language].categories[name] || name,
    localizeCategoryItems: (name, fallback) => translations[language].categoryItems[name] || fallback,
    localizeMethod: (name) => translations[language].methods[name] || name,
    translatePhrase: (value) => translatePhrase(value, language),
  }), [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}
